import { render, staticRenderFns } from "./baby.vue?vue&type=template&id=09561f0a&scoped=true&"
import script from "./baby.vue?vue&type=script&lang=js&"
export * from "./baby.vue?vue&type=script&lang=js&"
import style0 from "./baby.vue?vue&type=style&index=0&id=09561f0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09561f0a",
  null
  
)

export default component.exports